<template>
  <generic-modal :modal-key="'daily-bonus-spin-wheel'"
                 :classStyle="'new_achievement_box modal_cont'"
                 :idProp="'wheel_prize_modal'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ getTranslations.home_bonus_header }}
        <br> {{ getTranslations.home_bonus_you_won }} {{ quantity }} {{ getTranslations.home_bonus_spinning_wheel }}
      </h1>
      <img src="static/images/achievements/prize-spin.svg" class="prize_spin_img">
      <button type="" class="claim_prize" @click.prevent="spin()">{{ getTranslations.home_bonus_button_proceed }}
      </button>
    </template>
  </generic-modal>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import modals from '@/common/modals';
import SpinWheel from '../../spinwheel/SpinWheel';
import GenericModal from '../../../sharedcomponents/GenericModal';

export default {
  name: 'daily-bonus-spin-wheel',
  components: { GenericModal },
  data() {
    return {
      quantity: 1,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'saveBonusDailyModal',
      'setNotificationRewardId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setCheckedNotificationId',
    ]),
    spin() {
      const { spinningPrizeDesc, spinningPrizeWon, id } = this.bonusDailyModal;
      const spinNotification = (this.notifications || []).filter(notification => notification.gameId === parseInt(id, 10))[0];

      this.setCheckedNotificationId({ value: spinNotification.id });
      this.setNotificationRewardId({ value: id });
      this.setNotificationRewardName({ value: spinningPrizeDesc });
      this.setNotificationPrizeWon({ value: spinningPrizeWon });
      this.storeModalForHomePage(SpinWheel);
      modals.showHideModal(this);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
      'notifications',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/daily_bonus_modals/DailyBonusSpinningWheel.vue